export const EBillRateType = {
  FLAT: "flat",
  PERCENTAGE: "percentage",
  MARKUP_DOLLAR: "markup_dollar",
} as const;

export type TBillRateType = (typeof EBillRateType)[keyof typeof EBillRateType];

export const BillRateTypeValues = Object.values(
  EBillRateType
) as TBillRateType[];
